import React from "react";
import i18n from "~/assets/js/Helpers/i18n";
import { PlusCircle, MinusCircle } from "react-feather";
import Button from "../Button";
import { useCartContext } from "~/assets/js/global/cartContext";

const Cutlery = () => {
    const { cart, actions } = useCartContext();
    const { iconPath } = reactConfig;
    const toggleCutlery = async () => {
        await actions.updateCutlery(!cart.cutlery);
    };

    const CTA_text = cart?.cutlery
        ? i18n.t("cart.cutlery.takenCutlery")
        : i18n.t("cart.cutlery.takeCutlery");

    const CTA_icon = cart?.cutlery ? <MinusCircle /> : <PlusCircle />;

    return (
        <div className={`cart-box ${cart?.cutlery ? "cutlery__taken" : ""}`}>
            <div className="cart-box__image">
                <img
                    src={`${iconPath}/cutlery-new.svg`}
                    alt="cutlery_knife_fork"
                />
            </div>
            <div className="cart-box__content">
                <div className="cart-box__header">
                    <h5 className="cart-box__title">
                        {i18n.t("cart.cutlery.label")}
                    </h5>
                    <h5 className="cutlery__free">
                        {i18n.t("cart.cutlery.free")}
                    </h5>
                </div>

                <p className="cart-box__text">{i18n.t("cart.cutlery.text")}</p>
                <div className="cart-box__action">
                    <Button
                        label={CTA_text}
                        icon={CTA_icon}
                        onClick={toggleCutlery}
                        variant="secondary"
                        size="XS"
                    />
                </div>
            </div>
        </div>
    );
};

export default Cutlery;
